/*
export const someGetter = (state) => {}
 */
import _ from 'lodash'
import moment from 'moment'
export default {
  stateCourseOptions
  // studentCompletionReport,
  // studentCompletionExceptionReport,
  // studentCompletionExceptionMap
}

function stateCourseOptions (state, getters, rootState, rootGetters) {
  return Array.isArray(state.stateCourseList) && state.stateCourseList.length ? state.stateCourseList.map(course => { 
    return { label: course.COURSE_NAME, value: course.COURSE_ID, item: course }
  }) : []
}

// function studentCompletionReport (state) {
//   return state.studentCompletionList.map(studentCompletion => {
//     let row = { }
//     studentCompletion.forEach(item => {
//       if (item.field === "DOB") {
//         row[item.field] = moment(item.value, 'MMDDYY').format('MM/DD/YYYY')
//       } else if (item.field === "COMPLETED_DATE") {
//         row[item.field] = moment(item.value, 'YYYYDDMM').format('MM/DD/YYYY')
//       } else {
//         row[item.field] = item.value
//       }

//       if (item.exceptionInfo) {
//         row.exceptionInfo = item.exceptionInfo
//       }
//     })
//     return row
//   })
// }

// function studentCompletionExceptionReport (state, getters) {
//   return _.map(getters.studentCompletionReport, (studentCompletion, index) => {
//     studentCompletion.exception = getters.studentCompletionExceptionMap[index]
//     // studentCompletion.exceptionInfo = getters.[index][8].exceptionInfo
//     return studentCompletion
//   }).filter(item => item.exception)
// }

// function studentCompletionExceptionMap (state) {
//   return state.studentCompletionList.map(studentCompletion => {
//     return _.some(studentCompletion.map(item => item.exception))
//   })
// }
